<template>
  <div>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">新闻动态</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>广东东进在行动</h2>
        <img width="100%" :src="img[0]" alt="" />
        <p>
          在这个全国举家团圆的重要节日，回家成为每个异乡人的首要期盼。而面对“新型冠状病毒”这一非常情况，受命危难之时的广大东进人春节期间，放弃回家的机会，放弃假期、放弃与家人团聚，冒着病毒感染的风险，，沉静而勇敢，积极行动，投入到抗击”新型病毒"的战斗中。为筑走坚固防线，根据相关市领导提出的:“明确责任、堵防结合:抓好三个关键点，做到四个确保，处理好三个关系:不计一切代价，抗击疫情”的作要求，东进人同心同德面对这场没有硝烟的战争，坚决服从上级领导的命令，服从安排、无条件支持抗击疫情、义不容辞!
        </p>
        <p>
          李宗国、詹书刚等同志发挥党员带头示范作用，把党的旗帜高高举起来，重温入党暂词，把党的声音源源不断传播开来，把党员形象积极展出彩，把上级党支部的战斗堡垒作用充分发挥，以战斗的姿态迎接考验，迎接挑战。在抗击新的肺炎病毒，我们就是战士，是战士，就只能冲锋没有任何理由退缩。这说出了广大东进人的共同心声。这是一个无悔的选择，这更是一个坚定的承诺。
        </p>
        <p>
          我们虽然没有豪言壮语，也没有轰轰列烈的行为，但是立足岗位，默默地在各个服务单位筑起了一道道安全可守的防线，一处处坚如警石的闸，用对客户身体健康生命安全高度负责的精神和行动，践行着"不忘初心牢记使命"的重要思想大东进人顾全大局，服务抗击疫情的同时保证做好本职工作。让我们风雨同舟，众志成城，建立同心，共同战斗，为取得新型冠状病毒肺炎抗击战的全面胜利而奋斗!
        </p>
        <img width="100%" :src="img[1]" alt="" />
      </div>
      <br />
      <br />
      <el-row :gutter="20">
        <el-col :span="12" :xs="24" :offset="0">
          <span style="cursor: pointer; color: #666; font-size: 14px" @click="$router.push({ name: 'News3' })">&lt;
            上一条&nbsp;&nbsp;&nbsp;&nbsp;东莞首例！两家国企...</span>
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" style="text-align: right" class="hidden-xs-only">
          <span style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'News1' })">热心公益献爱心...&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span>
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" class="hidden-sm-and-up">
          <span style="cursor: pointer; color: #666; font-size: 14px" @click="$router.push({ name: 'News1' })">下一条 &gt;
            &nbsp;&nbsp;&nbsp;&nbsp;热心公益献爱心...</span>
        </el-col>
      </el-row>
      <br />
      <br />
    </el-card>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        img: [require('@/assets/news3.png'), require('@/assets/news3-1.png')]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .kongxi {
    height: 10px;
  }

  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      font-family: 黑体, SimHei;
      font-size: 24px;
      margin: 20px 0;
      text-align: center;
    }

    p {
      font-size: 16px;
      margin: 20px 0;
      text-align: justify;
      text-indent: 2em;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }

  @media screen and (max-width: 768px) {
    .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      font-family: 黑体, SimHei;
      font-size: 24px;
      margin: 20px 0;
      text-align: center;
    }

    p {
      font-size: 16px;
      margin: 20px 0;
      text-align: justify;
      text-indent: 2em;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }
  }
</style>